const createEvent =
	(name: string) =>
	(celebration: { id: string; type: string }): [string, { celebrationId: string; type: string }] => [
		name,
		{ celebrationId: celebration.id, type: celebration.type },
	];

const createCommentEvent =
	(name: string) =>
	(data: {
		celebrationId: string;
		type: string;
		amount: number;
		userId: string;
	}): [string, { celebrationId: string; type: string; amount: number; userId: string }] => [name, data];

export const deactivate = createEvent('Deactivate Celebration');
export const reactivate = createEvent('Reactivate Celebration');
export const reset = createEvent('Reset Celebration to Default');
export const review = createEvent('Review Celebration');
export const view = createEvent('View Celebration Settings');
export const edit = createEvent('Edit Celebration');
export const editFailure = createEvent('Edit Celebration Failure');
export const createCelebrationCommentEvent = createCommentEvent('Celebration Comment Created');
